import instance from './axiosInstance';

export function getProfileApplications(options = {}) {
  return instance.get(`/applications`, options);
}

export function setDefaultAccount(reqBody = {}, options = {}) {
  return instance.put(`/user/profile/default`, reqBody, options);
}

export function setDefaultApp(reqBody = {}, options = {}) {
  return instance.put(`/application/default`, reqBody, options);
}
